import React, { useState, useEffect, useRef } from 'react';
import { faBars, faClose, faUser, faFileLines, faHouse } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { DropdownHeader, Dropdown, Button, Nav } from "react-bootstrap";
import { Link, useHistory } from 'react-router-dom';
import Acontrol from '../../assets/images/access-control.png';
import Air from '../../assets/images/air.png';
import Awb from '../../assets/images/awb.png';
import bell from '../../assets/images/bell.png';
import logo from '../../assets/images/cargohub-logo.png';
import Profile from "../../assets/images/fds.png";
import Filter from '../../assets/images/filter.png';
import grid from '../../assets/images/grid.png';
import Package from '../../assets/images/package.png';
import Offline from '../../assets/images/offline.png';
import Airline_icon from '../../assets/images/plane.png';
import Rfs_icon from '../../assets/images/module_icon.png';
import Traker_icon from '../../assets/images/traker_icon.png';
import handler_icon from '../../assets/images/warehouse.png';


import Setting from '../../assets/images/setting.png';
import Homes from '../../assets/images/homes.png';
import Switch from '../../assets/images/swap.png';
import Manual from '../../assets/images/manual.png';

import Flight from "../../assets/images/Flight.png";
import SReco from "../../assets/images/serv_reco.png";
import Monitor from "../../assets/images/Monitor.png";
import Rfs from "../../assets/images/Rfs.png";
import Uldm from "../../assets/images/Uldm.png";
import Ulddam from "../../assets/images/ulddam.png";
import Settings from "../../assets/images/settings.png";
import Cusreport from "../../assets/images/cusreport.svg";
import Claim from "../../assets/images/claim.svg";

import Semester from "../../assets/images/semester.png";
import Events from "../../assets/images/events.png";
import Learing from "../../assets/images/e-learing.png";
import Inspection from "../../assets/images/inspection.png";
import Quality from "../../assets/images/quality.png";
import License from "../../assets/images/pick-list.png";

import Truck_info from "../../assets/images/truck-inspection.png"
import Export_in from "../../assets/images/export_en.png"

import {
    useAuth, useAuthRFS, useAuthULD, useAuthASR, useAuthHSR,
    useAuthAirline, useAuthTrucking, useAuthHRFS, useAuthHandler,
    useAuthFSHP, useAuthFULD, useAuthHSPL, useAuthForwarder, useAuthFTM, useAuthTKM, useAuthFDVR, useAuthQMS, useAuthHULD,
    useAuthQUT
} from '../../useAuth/useAuth';

import MANUAL from '../../assets/Manual-ULD-Control-Airlines.pdf'

import { setRedirecting } from "../../App";
import { toast } from 'react-toastify';
import { withRFSToken } from '../../Services/axios';

import { CallApi, Logout } from '../../Components/common/CommonFunctions.js';
import { handleRedirect } from '../../Pages/Dashboard/SAComponents/HandleRedirect.js';
import { useUserCheckQuery } from '../../redux/services/Auth.js';
import { AddSession } from '../../useAuth/SessionExtract.js';
// import { withRFSToken } from '../../Services/axios';
// import { ULDBACK } from '../../Utils/conts';


const Header = ({ page_type, logo_url, mode, sBackUrl, hideIcon }) => {

    const isMounted = useRef(false);
    const history = useHistory();
    const [userDetails, setUserDetails] = useState();

    const isAuthenticatedAirline = useAuthAirline();
    const isAuthenticatedHandler = useAuthHandler();
    const isAuthenticatedForwarder = useAuthForwarder();
    const isAuthenticated = useAuth();
    const isAuthenticatedRFS = useAuthRFS();
    const isAuthenticatedTrucking = useAuthTrucking();
    const isAuthenticatedULD = useAuthULD();
    const isAuthenticatedASR = useAuthASR();
    const isAuthenticatedHSR = useAuthHSR();
    const isAuthenticatedHRFS = useAuthHRFS();
    const isAuthenticatedFSHP = useAuthFSHP();
    const isAuthenticatedFULD = useAuthFULD();
    const isAuthenticatedHSPL = useAuthHSPL();
    const isAuthenticatedFTM = useAuthFTM();
    const isAuthenticatedTKM = useAuthTKM();
    const isAuthenticatedDVR = useAuthFDVR();
    const isAuthenticatedQMS = useAuthQMS();
    const isAuthenticatedHULD = useAuthHULD();
    const isAuthenticatedQUT = useAuthQUT();

    const adminCheck = localStorage.getItem('Email');
    const backUrl = localStorage.getItem('GoBack');
    const airlineToken = localStorage.getItem('airlinetoken');
    const truckingToken = localStorage.getItem('Trucking');
    const userType = localStorage.getItem('UserType');
    const uTypes = ['SA', 'S']; // 

    const getTz = JSON.parse(localStorage.getItem('timeZone'));
    const [notificationData, setNotificationData] = useState([]);
    const [countUnread, setCountUnread] = useState();


    const fetchnotification = async () => {
        try {
            const res = await withRFSToken.post('notification/user-notification-list', { type: page_type })
                .then(function (res) {
                    const innerData = res.data.response_data;
                    // console.log("🚀 ~ .then ~ innerData:654", innerData)
                    // const unreadData = innerData?.filter(un => un.seen_status === '1').length;
                    setCountUnread(innerData.unseen_list_count)
                    setNotificationData(innerData.all_list);
                });


        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchTimeZone = () => {
        CallApi({
            endPoint: 'organization-timezone/get',
            method: 'get',
            onSuccess: (data) => {
                const resCode = data.data.response_code;
                if (resCode === 200) {
                    const innerData = data.data.response_data;
                    localStorage.setItem("timeZone", JSON.stringify(innerData))
                }
            },
            onError: (msg) => toast.error(msg)
        });
    };

    useEffect(() => {
        // Call the fetchData function to fetch data from the API
        if (isMounted.current) return;
        fetchnotification();
        if (!getTz) {
            fetchTimeZone()
        }
        isMounted.current = true;
    }, []);

    const { data: myData } = useUserCheckQuery('', {
        // skip: pageDetails.pagesize === 0,
    });
    useEffect(() => {
        if (myData?.response_data) {
            setUserDetails(myData?.response_data);
        }
    }, [myData]);

    const toggleBodyClass = () => {
        document.body.classList.toggle('sidebar-icon-only');
    };

    const [isIconClosed, setIsIconClosed] = useState(false);

    const handleIconClick = () => {
        setIsIconClosed(!isIconClosed);
        document.body.classList.toggle('sidebar-icon-only');
        // Add your additional logic or toggle state as needed
    };

    const handleSwitchBack = (e) => {
        e.preventDefault();
        // const url = localStorage.getItem('GoBack');
        // window.location.href = url;
        CallApi({
            endPoint: 'move-to-super-admin',
            // payload: { id: dt.id, is_deleted: st },
            onSuccess: (data) => {
                // console.log('sendData', data);
                const resCode = data.data.response_code;
                if (resCode === 200) {
                    const innerData = data.data.response_data;
                    // loadDetails();
                    AddSession('__A-', innerData)
                    const sendData = { ...innerData, loc: '/SuperAdmin', token_name: 'SAToken', tab_name: 'O' }
                    // handleRedirect(sendData)
                    window.location.replace('/SuperAdmin')
                    // history.replace('/SuperAdmin')
                } else {
                    toast.error(data.response_msg);
                }
            },
            onError: (msg) => toast.error(msg)
        });
    }
    const orgType = localStorage.getItem('OrgType');
    const orgName = localStorage.getItem('OrgName');
    const HandleBack = (e) => {
        // console.log(e);

        e.preventDefault();
        // const url = localStorage.getItem('GoBack');
        // window.location.href = url;
        if (sBackUrl) {
            window.location.replace(sBackUrl);
        } else {
            history.push('/Dashboard');
            // const tokenTypes = ['ULD', 'RFS', 'ASR', 'SPL', 'FTM', 'TKM', 'DVR', 'QMS', 'QUT'];
            // for (let type of tokenTypes) {
            //     const tokenValue = localStorage.getItem(type);
            //     // const orgType = localStorage.getItem('OrgType');
            //     if (tokenValue) {
            //         // if (orgType === 'A') {
            //         //     localStorage.setItem('airlinetoken', tokenValue);
            //         // } else if (orgType === 'H') {
            //         //     localStorage.setItem('handlertoken', tokenValue);
            //         // } else {}
            //         localStorage.setItem('airlinetoken', tokenValue);
            //         localStorage.removeItem(type);
            //         setRedirecting(true);
            //         history.push('/Dashboard');
            //     }
            // }

            // commented for login
        }

        // try {
        //     const res = await withRFSToken.post(ULDBACK, {});
        //     if (res.data.response_code == 200) {
        //         const innerData = res.data.response_data;
        //         // const fnPageUrl = '/ULDControl/ULDFunction'; 
        //         window.location.href = innerData;
        //     } else { toast.error(res.data.response_msg) }
        // } catch (error) {
        //     console.error('Error fetching data:', error);
        // }
    }

    const settingsClick = (e) => {
        e.preventDefault();
        const relativePath = '/' + new URL(window.location.href).pathname.replace(/^\/+/, '');
        localStorage.setItem('SettingsBack', relativePath);
        localStorage.removeItem('STab');
        // let redirectPath = '#';
        // switch (true) {
        //     case isAuthenticated:
        //         redirectPath = '/UserSettings';
        //         break;
        //     case isAuthenticatedRFS:
        //         redirectPath = '/RFSControlSettings';
        //         break;
        //     case isAuthenticatedULD :
        //         redirectPath = '/ULDControlSettings';
        //         break;
        //     case isAuthenticatedASR :
        //         redirectPath = '/ServiceRecoverySettings';
        //         break;
        //     case isAuthenticatedFULD:
        //         redirectPath = '/ForwarderULDSettings';
        //         break;
        //     case isAuthenticatedFSHP:
        //         redirectPath = '/ShipmentManagerSettings';
        //         break;
        //     case isAuthenticatedHSR:
        //         redirectPath = '/ServiceRecoverySettings';
        //         break;
        //     case isAuthenticatedAirline:
        //         redirectPath = '/AirlineSettings';
        //         break;
        //     case isAuthenticatedForwarder:
        //         redirectPath = '/ForwarderSettings';
        //         break;
        //     case isAuthenticatedHandler:
        //         redirectPath = '/HandlerSettings';
        //         break;
        //     case isAuthenticatedHSPL:
        //         redirectPath = '/SlotPlanningSettings';
        //         break;
        //     case isAuthenticatedHULD:
        //         redirectPath = '/HandlerULDSettings';
        //         break;
        //     // case isAuthenticatedFULD:
        //     //     redirectPath = '/GeneralSettings';
        //     //     break;
        //     // case isAuthenticatedFSHP:
        //     //     redirectPath = '/GeneralSettings';
        //     //     break;
        //     default:
        //         redirectPath = '#';
        // }

        // window.location.replace(redirectPath);
        // window.location.href = '/Settings';
        history.push('/Settings');
    }

    const hSettingsClick = (e) => {
        e.preventDefault();
        const relativePath = '/' + new URL(window.location.href).pathname.replace(/^\/+/, '');
        localStorage.setItem('SettingsBack', relativePath);
        history.push('/UserSettings');
    }

    const isSidebarIconOnly = document.body.classList.contains('sidebar-icon-only');

    const logOut = () => {
        // const token = useAuth();
        // console.log("logout==>", localStorage.getItem('token'));

        //    localStorage.removeItem("token");
        //    localStorage.removeItem("RFS");
        // window.location.replace(process.env.REACT_APP_ITS_2_BASE_URL)
        // const logoutUrl = localStorage.getItem('LogOut');
        // localStorage.clear();
        // console.log("🚀 ~ logOut ~ logoutUrl:", logoutUrl)
        // window.location.replace(logoutUrl);
        //    if(!token) {
        //     window.location.replace(process.env.REACT_APP_ITS_2_BASE_URL)
        //     return null;
        // }


        //    localStorage.clear();
        //    const detailsPageUrl = `/`; 
        //   window.location.href = detailsPageUrl;
        CallApi({
            endPoint: "/logout",
            payload: {},
            method: "post",
            onSuccess: () => {
                localStorage.clear();
                sessionStorage.clear();
                history.replace('/Login');
            },
            // onError: (error) => {
            //     localStorage.clear();
            //     history.push(logoutUrl);
            // }
        });

    }

    const handleNavigation = (path) => {
        const uldValue = localStorage.getItem('ULD');
        if (uldValue) {
            localStorage.setItem('RFS', uldValue);
            localStorage.removeItem('ULD');
            history.push(path);
        } else {
            // Handle the case where 'ULD' is not in localStorage
            console.log('ULD value not found in localStorage');
        }
    };
    const handleNavigationULD = (path) => {
        const uldValue = localStorage.getItem('RFS');
        if (uldValue) {
            localStorage.setItem('ULD', uldValue);
            localStorage.removeItem('RFS');
            history.push(path);
        } else {
            // Handle the case where 'ULD' is not in localStorage
            console.log('ULD value not found in localStorage');
        }
    };
    const downloadManual = (e) => {
        e.preventDefault(); // Prevent the default link behavior
        // const pdfUrl = '/Manual-ULD-Test.pdf'; // Path from the public directory
        const a = document.createElement('a');
        a.href = MANUAL;
        a.download = 'Manual-ULD-Control-Airlines.pdf';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    };

    const airlineCdmClick = (nav) => {
        const tokenTypes = ['ULD', 'RFS', 'ASR'];
        const existingTokenKey = tokenTypes.find((type) => localStorage.getItem(type));

        // If the current nav matches the existing token, do nothing
        if (existingTokenKey === nav) {
            toast.error('You are already in the system')
            return;
        } else {
            const tokenValue = localStorage.getItem(existingTokenKey);
            localStorage.setItem(nav, tokenValue);
        }

        tokenTypes.forEach((type) => {
            if (type !== nav) {
                localStorage.removeItem(type);
            }
        });

        switch (nav) {
            case 'ULD':
                history.push('/ULDControl');
                break;
            case 'RFS':
                history.push('/BookingtruckSchedule');
                break;
            case 'ASR':
                history.push('/ServiceRecovery');
                break;
            default:
                console.error('Invalid navigation type');
        }
    };
    const forwarderCdmClick = (nav) => {
        const tokenTypes = ['ULD', 'RFS', 'DVR'];
        const existingTokenKey = tokenTypes.find((type) => localStorage.getItem(type));

        // If the current nav matches the existing token, do nothing
        if (existingTokenKey === nav) {
            toast.error('You are already in the system')
            return;
        } else {
            const tokenValue = localStorage.getItem(existingTokenKey);
            localStorage.setItem(nav, tokenValue);
        }

        tokenTypes.forEach((type) => {
            if (type !== nav) {
                localStorage.removeItem(type);
            }
        });

        const shpTab = localStorage.getItem('FSTab');

        switch (nav) {
            case 'ULD':
                history.push('/ULDForwarder/ActiveTrips');
                break;
            case 'RFS':
                history.push(`/ForwarderShipments/${shpTab ? shpTab : 'ShipmentRecords'}`);
                break;
            case 'DVR':
                history.push(`/DVRegistration/Driver`);
                break;
            default:
                console.error('Invalid navigation type');
        }
    }
    const airlineCCLP = async (tab) => {
        try {
            const res = await withRFSToken.post('cclp-login', { tab_name: tab })
                .then(function (res) {
                    const innerData = res.data.response_data;
                    history.push(innerData)
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }
    const forwarderCCLP = async (tab) => {
        try {
            const res = await withRFSToken.post('cclp-login', { tab_name: tab })
                .then(function (res) {
                    const innerData = res.data.response_data;
                    history.push(innerData)
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    const notificationClick = async (id, status, uldId) => {
        if (status !== 1) {
            let ids;
            if (id === 'All') {
                const allIds = notificationData?.map(id => id.notification_id)
                ids = allIds;
            } else {
                ids = [id]
            }
            // console.log('IDS',ids);
            try {
                const res = await withRFSToken.post('notification/user-notification-status', { notification_id: ids })
                    .then(function (res) {
                        fetchnotification();
                    });
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        }

        if (uldId) {
            try {
                const res = await withRFSToken.post('get-uld-details', { uld_id: uldId })
                    .then(function (res) {
                        if (res.data.response_code === 200) {
                            const tokenName = localStorage.getItem('airlinetoken')
                            const storageData = {
                                ULD: res.data.response_data,  // ULD Details section
                                Form: {}  // Empty form section
                            };
                            localStorage.setItem('MHistory', JSON.stringify(storageData));

                            if (tokenName) {
                                localStorage.setItem('ULD', tokenName);
                                localStorage.removeItem('airlinetoken');
                                history.push = '/ULDControl/MovementHistory'
                            } else {
                                history.push = '/ULDControl/MovementHistory'
                            }

                        }
                    });
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        }
    };

    const handleSwitchAdmin = () => {
        const token = localStorage.getItem('Husertoken')
        if (token) {
            localStorage.setItem('airlinetoken', token)
            localStorage.removeItem('Husertoken')
            history.push('/HandlerAdmin');
        } else {
            history.push('/HandlerAdmin');
        }
    }

    // const orgLogo = localStorage.getItem('orgLogo')
    // const orgNmae = localStorage.getItem('OrgName')

    return (
        <>
            {/* {console.log("userDetails == HEADER", userDetails)} */}
            <div className="d-flex header-main">
                <div className="left-section">
                    {page_type !== 'airline' && !isAuthenticatedTrucking &&
                        <div className="hmenu">
                            <button className="navbar-toggler navbar-toggler align-self-center" type="button" onClick={handleIconClick}>
                                <FontAwesomeIcon icon={isSidebarIconOnly ? faClose : faBars} />
                            </button>
                        </div>
                    }
                    {/* <a href={isAuthenticated ? '/planDashboard' :
                        (isAuthenticatedRFS ? '/BookingtruckSchedule' :
                            (isAuthenticatedULD ? '/ULDControl' :
                                (isAuthenticatedASR ? '/ServiceRecovery' :
                                    (isAuthenticatedHRFS ? '/HandlerRecovery' :
                                        (isAuthenticatedAirline ? '/Dashboard' : '')))))} className="logo-main"> */}
                    <a href={logo_url} className="logo-main">
                        {/* <img src={orgNmae == 'El Al Israel Airlines' && orgLogo ? orgLogo : logo} /> */}
                        <img src={userDetails?.org_logo ?? logo} />
                        {/* {page_type === 'srecovery' ?
                            <> <span className='top_service'> <img alt='CARGOHUB' src={Package} /> SERVICE RECOVERY </span></>
                            : (page_type == 'airline' ?
                                <> <span className='top_service'> <img alt='CARGOHUB' src={Airline_icon} /> AIRLINE </span></>
                                : (page_type == 'handler' ?
                                    <> <span className='top_service'> <img alt='CARGOHUB' src={handler_icon} /> Handler </span></>
                                    : (page_type == 'forwarder' || page_type == 'fsm' ?
                                        <> <span className='top_service'> <img alt='CARGOHUB' src={handler_icon} /> Forwarder </span></>
                                        : '')))} */}
                    </a>
                </div>
                <div className="right-section">
                    <ul className="navbar-nav">
                        {page_type !== 'airline' && !isAuthenticatedTrucking && page_type !== 'handler' && page_type !== 'forwarder' &&//  && !isAuthenticatedHSR   &&
                            <Link className="ralink raback" to="#" onClick={HandleBack}> <img alt='Home' src={Homes} /> </Link>
                        }
                        {isAuthenticatedTrucking && hideIcon &&//  && !isAuthenticatedHSR   &&
                            <Link className="ralink raback" to="#" onClick={HandleBack}> <img alt='Home' src={Homes} /> </Link>
                        }
                        {/* {(isAuthenticatedAirline || isAuthenticatedTrucking || isAuthenticatedHandler) && // page_type === 'airline' */}
                        {/* {adminCheck === 'admin@castusinfo.com' && backUrl && */}
                        {mode == 'SA' && uTypes.includes(userDetails?.login_user_type) && // airlineToken &&
                            <Link className="ralink raback" to="#" onClick={handleSwitchBack}> <img alt='Switch' src={Switch} /> Switch </Link>
                        }
                        {/* {!mode && userType == 'SA' && isAuthenticatedHandler && */}
                        {!mode && userDetails?.user_type == 'SA' && userDetails?.org_type === 'H' &&
                            <Link className="ralink raback" to="#" onClick={handleSwitchAdmin}> <img alt='Switch' src={Switch} /> Switch </Link>
                        }
                        {uTypes.includes(userDetails?.user_type) && truckingToken && (!hideIcon) &&
                            <Link className="ralink raback" to="#" onClick={handleSwitchBack}> <img alt='Switch' src={Switch} /> Switch </Link>
                        }
                        {isAuthenticatedRFS && ['Campus Airlines', 'Oman Air', 'Etihad Crystal Cargo'].includes(userDetails?.org_name) &&
                            <Link className="ralink raback" to="#" onClick={() => window.location.href = 'https://rfs.qms-test2.qms-test.com/demo-login'}> <img alt='Switch' src={Switch} /></Link>
                        }
                        {/* {!isAuthenticatedASR &&
                            !isAuthenticatedHSR &&
                            page_type !== 'airline' &&
                            page_type !== 'handler' &&
                            page_type !== 'Handler' &&
                            page_type !== 'forwarder' &&
                            !isAuthenticatedTrucking &&
                            !isAuthenticatedHandler &&
                            !isAuthenticatedRFS &&
                            !isAuthenticatedFULD &&
                            !isAuthenticatedFSHP &&
                            !isAuthenticatedHSPL &&
                            !isAuthenticatedFTM &&
                            !isAuthenticatedTKM &&
                            !isAuthenticatedDVR &&
                            <Link className="ralink raback" to="" onClick={downloadManual}> <img alt='Manual' src={Manual} /> </Link>
                        } */}
                        {isAuthenticatedULD &&
                            <Link className="ralink raback" to="" onClick={downloadManual}> <img alt='Manual' src={Manual} /> </Link>
                        }
                        {!isAuthenticatedHandler &&
                            !isAuthenticatedTrucking &&
                            page_type !== 'airline' &&
                            !isAuthenticatedFTM &&
                            !isAuthenticatedTKM &&
                            // !isAuthenticatedDVR &&
                            page_type !== 'settings' && // !isAuthenticatedHSR &&
                            !isAuthenticatedQMS && !hideIcon &&
                            <Link className="ralink" to='#' onClick={settingsClick}><img alt='' src={Setting} /></Link>
                        }
                        {isAuthenticatedTrucking && userDetails?.user_type == 'SA' && !hideIcon &&
                            <Link className="ralink" to='#' onClick={settingsClick} ><img alt='' src={Setting} /></Link>
                        }
                        {isAuthenticatedHandler && mode == 'SA' && !hideIcon &&
                            <Link className="ralink" to='#' onClick={settingsClick} ><img alt='' src={Setting} /></Link>
                        }
                        {page_type === 'airline' && uTypes.includes(userDetails?.user_type) && !hideIcon &&
                            <Link className="ralink" to='#' onClick={settingsClick}><img alt='' src={Setting} /></Link>
                        }
                        {(page_type == 'airline' || page_type == 'handler' || page_type == 'forwarder') &&
                            <>
                                <Link className="ralink position-relative" to="#" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight">  <img alt='' src={bell} /> {countUnread > 0 && (<span className='unread'>{countUnread > 99 ? '99+' : countUnread}</span>)}
                                </Link>
                                <div className="offcanvas offcanvas-end notification_side" tabIndex="-1" id="offcanvasRight" aria-labelledby="offcanvasRightLabel">
                                    <button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                                    <div className="offcanvas-header">
                                        <h5>Notifications {countUnread > 0 && <span>{countUnread}</span>}</h5>
                                    </div>
                                    <div className="offcanvas-body">

                                        <div>
                                            <nav className='noti_tab'>
                                                <div className="nav nav-tabs" id="nav-tab" role="tablist">
                                                    <button className="nav-link active" id="nav-home-tab" data-bs-toggle="tab" data-bs-target="#nav-home" type="button" role="tab" aria-controls="nav-home" aria-selected="true">ALL</button>
                                                    <button className="nav-link" id="nav-profile-tab" data-bs-toggle="tab" data-bs-target="#nav-profile" type="button" role="tab" aria-controls="nav-profile" aria-selected="false">CDM</button>
                                                    <button className="nav-lin k" id="nav-contact-tab" data-bs-toggle="tab" data-bs-target="#nav-contact" type="button" role="tab" aria-controls="nav-contact" aria-selected="false">CCLP</button>
                                                    <button className="nav-lin k" id="nav-contact-tab" data-bs-toggle="tab" data-bs-target="#nav-contact" type="button" role="tab" aria-controls="nav-contact" aria-selected="false">QMS</button>
                                                </div>
                                            </nav>
                                            <div className="tab-content" id="nav-tabContent">
                                                <div className="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
                                                    {notificationData?.map((note, index) => (
                                                        <>
                                                            <div className="d-flex align-items-center notibox" key={`${index}_motr`} onClick={() => notificationClick(note.notification_id, note.seen_status, note.uld_id)}>
                                                                <span className={note.seen_status == 0 ? 'unread' : 'read'}></span>
                                                                <div className="notifyimg"><img alt='' src={Profile} /></div>
                                                                <div className="notifytxt">
                                                                    <p><b>{note.notification_value}</b>{note.notification_text}</p>
                                                                    <p> {note.notification_for} <small>{note.notification_date}</small></p>
                                                                </div>
                                                            </div>
                                                        </>
                                                    ))}
                                                    {/* <div className="d-flex align-items-center notibox">
                                                        <span className='unread'></span>
                                                        <div className="notifyimg"><img alt='' src={Profile} /></div>
                                                        <div className="notifytxt">
                                                            <p><b>ULD PMC1234ZZZ</b> has not moved for 30 day's</p>
                                                            <p> ULD Control <small>09:30 01/12/2024</small></p>
                                                        </div>
                                                    </div>
                                                    <div className="d-flex align-items-center notibox">
                                                        <span className='unread'></span>
                                                        <div className="notifyimg"><img alt='' src={Profile} /></div>
                                                        <div className="notifytxt">
                                                            <p><b>ULD PMC1234ZZZ</b> has not moved for 30 day's</p>
                                                            <p> ULD Control <small>09:30 01/12/2024</small></p>
                                                        </div>
                                                    </div>
                                                    <div className="d-flex align-items-center notibox">
                                                        <span className='unread'></span>
                                                        <div className="notifyimg"><img alt='' src={Profile} /></div>
                                                        <div className="notifytxt">
                                                            <p><b>ULD PMC1234ZZZ</b> has not moved for 30 day's</p>
                                                            <p> ULD Control <small>09:30 01/12/2024</small></p>
                                                        </div>
                                                    </div>
                                                    <div className="d-flex align-items-center notibox">
                                                        <span className='unread'></span>
                                                        <div className="notifyimg"><img alt='' src={Profile} /></div>
                                                        <div className="notifytxt">
                                                            <p><b>ULD PMC1234ZZZ</b> has not moved for 30 day's</p>
                                                            <p> ULD Control <small>09:30 01/12/2024</small></p>
                                                        </div>
                                                    </div> */}

                                                </div>
                                                <div className="tab-pane fade" id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab">...</div>
                                                <div className="tab-pane fade" id="nav-contact" role="tabpanel" aria-labelledby="nav-contact-tab">...</div>
                                                <div className="tab-pane fade" id="nav-contact" role="tabpanel" aria-labelledby="nav-contact-tab">...</div>
                                            </div>
                                        </div>
                                        <div className='notify_update'>
                                            <Link variant="light" to='#' className='mark_btn' onClick={() => notificationClick('All')}>Mark all as read</Link>
                                            <Button variant="primary" className='view_btn' >View all notifications</Button>
                                        </div>
                                    </div>
                                </div>
                            </>
                        }
                        {(isAuthenticatedULD || isAuthenticatedRFS || isAuthenticatedASR) && page_type !== 'Handler' &&
                            <>
                                <Link className="ralink position-relative" to="#" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight3" aria-controls="offcanvasRight">  <img alt='' src={bell} />{countUnread > 0 && (<span className='unread'>{countUnread > 99 ? '99+' : countUnread}</span>)}
                                </Link>
                                <div className="offcanvas offcanvas-end notification_side" tabIndex="-1" id="offcanvasRight3" aria-labelledby="offcanvasRightLabel">
                                    <button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                                    <div className="offcanvas-header">
                                        <h5>Notifications{countUnread > 0 && <span>{countUnread}</span>}</h5>
                                    </div>
                                    <div className="offcanvas-body">
                                        <div>
                                            <nav className='noti_tab'>
                                                <div className="nav nav-tabs" id="nav-tab" role="tablist">
                                                    <button className="nav-link active" id="nav-home-tab" data-bs-toggle="tab" data-bs-target="#nav-home" type="button" role="tab" aria-controls="nav-home" aria-selected="true">ALL</button>
                                                    <button className="nav-link" id="nav-profile-tab" data-bs-toggle="tab" data-bs-target="#nav-profile" type="button" role="tab" aria-controls="nav-profile" aria-selected="false">CDM</button>
                                                    <button className="nav-lin k" id="nav-contact-tab" data-bs-toggle="tab" data-bs-target="#nav-contact" type="button" role="tab" aria-controls="nav-contact" aria-selected="false">CCLP</button>
                                                    <button className="nav-lin k" id="nav-contact-tab" data-bs-toggle="tab" data-bs-target="#nav-contact" type="button" role="tab" aria-controls="nav-contact" aria-selected="false">QMS</button>
                                                </div>
                                            </nav>
                                            <div className="tab-content" id="nav-tabContent">
                                                <div className="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
                                                    {notificationData?.map((note, index) => (
                                                        <>
                                                            <div className="d-flex align-items-center notibox" key={`${index}_not`} onClick={() => notificationClick(note.notification_id, note.seen_status, note.uld_id)}>
                                                                <span className={note.seen_status == 0 ? 'unread' : 'read'}></span>
                                                                <div className="notifyimg"><img alt='' src={Profile} /></div>
                                                                <div className="notifytxt">
                                                                    <p><b>{note.notification_value}</b>{note.notification_text}</p>
                                                                    <p> {note.notification_for} <small>{note.notification_date}</small></p>
                                                                </div>
                                                            </div>
                                                        </>
                                                    ))}
                                                    {/* <div className="d-flex align-items-center notibox">
                                                        <span className='unread'></span>
                                                        <div className="notifyimg"><img alt='' src={Profile} /></div>
                                                        <div className="notifytxt">
                                                            <p><b>ULD PMC1234ZZZ</b> has not moved for 30 day's</p>
                                                            <p> ULD Control <small>09:30 01/12/2024</small></p>
                                                        </div>
                                                    </div>
                                                    <div className="d-flex align-items-center notibox">
                                                        <span className='unread'></span>
                                                        <div className="notifyimg"><img alt='' src={Profile} /></div>
                                                        <div className="notifytxt">
                                                            <p><b>ULD PMC1234ZZZ</b> has not moved for 30 day's</p>
                                                            <p> ULD Control <small>09:30 01/12/2024</small></p>
                                                        </div>
                                                    </div>
                                                    <div className="d-flex align-items-center notibox">
                                                        <span className='unread'></span>
                                                        <div className="notifyimg"><img alt='' src={Profile} /></div>
                                                        <div className="notifytxt">
                                                            <p><b>ULD PMC1234ZZZ</b> has not moved for 30 day's</p>
                                                            <p> ULD Control <small>09:30 01/12/2024</small></p>
                                                        </div>
                                                    </div>
                                                    <div className="d-flex align-items-center notibox">
                                                        <span className='unread'></span>
                                                        <div className="notifyimg"><img alt='' src={Profile} /></div>
                                                        <div className="notifytxt">
                                                            <p><b>ULD PMC1234ZZZ</b> has not moved for 30 day's</p>
                                                            <p> ULD Control <small>09:30 01/12/2024</small></p>
                                                        </div>
                                                    </div> */}

                                                </div>
                                                <div className="tab-pane fade" id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab">...</div>
                                                <div className="tab-pane fade" id="nav-contact" role="tabpanel" aria-labelledby="nav-contact-tab">...</div>
                                                <div className="tab-pane fade" id="nav-contact" role="tabpanel" aria-labelledby="nav-contact-tab">...</div>
                                            </div>
                                        </div>
                                        <div className='notify_update'>
                                            <Link variant="light" to='#' className='mark_btn' onClick={() => notificationClick('All')}>Mark all as read</Link>
                                            <Button variant="primary" className='view_btn' >View all notifications</Button>
                                        </div>
                                    </div>
                                </div>
                                <Link className="ralink" to="#" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight">
                                    <img alt='' src={grid} /> </Link>
                                <div className="offcanvas offcanvas-end notification_side" tabIndex="-1" id="offcanvasRight" aria-labelledby="offcanvasRightLabel">
                                    <button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                                    <div className="offcanvas-header">
                                        <div className='modul_head'>
                                            <h5>All Module - <span>Airline</span></h5>
                                            {/* <button onClick={HandleBack}><FontAwesomeIcon icon={faHouse} /> Home</button> */}
                                        </div>
                                    </div>
                                    <div className="offcanvas-body">
                                        <div className='module_airline'>
                                            <h3>CDM</h3>
                                            <div className='all_module'>
                                                <div className='module_item'>
                                                    <img alt='' src={Monitor} />
                                                    <p>AWB Monitor</p>
                                                </div>

                                                <div className='module_item'>
                                                    <img alt='' src={Flight} />
                                                    <p>Flight Monitor</p>
                                                </div>

                                                <div className='module_item' onClick={() => airlineCdmClick('RFS')}>
                                                    <img alt='' src={Rfs} />
                                                    <p>RFS Control Tower</p>
                                                </div>

                                                <div className='module_item' onClick={() => airlineCdmClick('ULD')}>
                                                    <img alt='' src={Uldm} />
                                                    <p>ULD Control</p>
                                                </div>
                                            </div>
                                        </div>

                                        <div className='module_airline'>
                                            <h3>CCLP</h3>
                                            <div className='all_module'>
                                                <div className='module_item' onClick={() => airlineCCLP('cargo-damage')}>
                                                    <img alt='' src={SReco} />
                                                    <p>Cargo Damage</p>
                                                </div>

                                                <div className='module_item' onClick={() => airlineCCLP('uld-damage')}>
                                                    <img alt='' src={Ulddam} />
                                                    <p>ULD Damage</p>
                                                </div>

                                                <div className='module_item' onClick={() => airlineCdmClick('ASR')}>
                                                    <img alt='' src={Settings} />
                                                    <p>Service Recovery</p>
                                                </div>

                                                <div className='module_item' onClick={() => airlineCCLP('customer-report')}>
                                                    <img alt='' src={Cusreport} />
                                                    <p>Customer Report</p>
                                                </div>

                                                <div className='module_item' onClick={() => airlineCCLP('cargo-claim')}>
                                                    <img alt='' src={Claim} />
                                                    <p>Cargo Claims</p>
                                                </div>
                                            </div>
                                        </div>

                                        <div className='module_airline'>
                                            <h3>QMS</h3>
                                            <div className='all_module'>
                                                <div className='module_item'>
                                                    <img alt='' src={Inspection} />
                                                    <p>Audit Control</p>
                                                </div>

                                                <div className='module_item'>
                                                    <img alt='' src={Events} />
                                                    <p>Event Manager</p>
                                                </div>

                                                <div className='module_item'>
                                                    <img alt='' src={Learing} />
                                                    <p>Training Manager</p>
                                                </div>

                                                <div className='module_item'>
                                                    <img alt='' src={Semester} />
                                                    <p>Training Scheduler</p>
                                                </div>

                                                <div className='module_item'>
                                                    <img alt='' src={Quality} />
                                                    <p>Document Manager</p>
                                                </div>

                                                <div className='module_item'>
                                                    <img alt='' src={License} />
                                                    <p>License Manager</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        }
                        {isAuthenticatedRFS &&
                            <>
                                {/* <Link className="ralink" to="#" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight">  <img alt='' src={grid} /> </Link>
                                <div className="offcanvas offcanvas-end notification_side" tabIndex="-1" id="offcanvasRight" aria-labelledby="offcanvasRightLabel">

                                    <button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>

                                    <div className="offcanvas-header">
                                        <div className='modul_head'>
                                            <h5>All Module - <span>Airline</span></h5>
                                            <button><FontAwesomeIcon icon={faHouse} /> Home</button>
                                        </div>
                                    </div>
                                    <div className="offcanvas-body">
                                        <div className='module_airline'>
                                            <h3>CDM</h3>
                                            <div className='all_module'>
                                                <div className='module_item'>
                                                    <img alt='' src={Monitor} />
                                                    <p>AWB Monitor</p>
                                                </div>
                                                <div className='module_item'>
                                                    <img alt='' src={Flight} />
                                                    <p>Flight Monitor</p>
                                                </div>
                                                <div className='module_item'>
                                                    <img alt='' src={Rfs} />
                                                    <p>RFS Control Tower</p>
                                                </div>
                                                <div className='module_item'>
                                                    <img alt='' src={Uldm} />
                                                    <p>ULD Control</p>
                                                </div>
                                            </div>
                                        </div>

                                        <div className='module_airline'>
                                            <h3>CCLP</h3>
                                            <div className='all_module'>
                                                <div className='module_item'>
                                                    <img alt='' src={SReco} />
                                                    <p>Cargo Damage</p>
                                                </div>

                                                <div className='module_item'>
                                                    <img alt='' src={Ulddam} />
                                                    <p>ULD Damage</p>
                                                </div>

                                                <div className='module_item'>
                                                    <img alt='' src={Settings} />
                                                    <p>Service Recovery</p>
                                                </div>

                                                <div className='module_item'>
                                                    <img alt='' src={Cusreport} />
                                                    <p>Customer Report</p>
                                                </div>

                                                <div className='module_item'>
                                                    <img alt='' src={Claim} />
                                                    <p>Cargo Claims</p>
                                                </div>
                                            </div>
                                        </div>

                                        <div className='module_airline'>
                                            <h3>QMS</h3>
                                            <div className='all_module'>
                                                <div className='module_item'>
                                                    <img alt='' src={Inspection} />
                                                    <p>Audit Control</p>
                                                </div>

                                                <div className='module_item'>
                                                    <img alt='' src={Events} />
                                                    <p>Event Manager</p>
                                                </div>

                                                <div className='module_item'>
                                                    <img alt='' src={Learing} />
                                                    <p>Training Manager</p>
                                                </div>

                                                <div className='module_item'>
                                                    <img alt='' src={Semester} />
                                                    <p>Training Scheduler</p>
                                                </div>

                                                <div className='module_item'>
                                                    <img alt='' src={Quality} />
                                                    <p>Document Manager</p>
                                                </div>

                                                <div className='module_item'>
                                                    <img alt='' src={License} />
                                                    <p>License Manager</p>
                                                </div>

                                            </div>

                                        </div>

                                    </div>
                                </div> */}

                            </>
                        }
                        {(isAuthenticatedFULD || isAuthenticatedFSHP || isAuthenticatedDVR) &&
                            <>
                                <Link className="ralink" to="#" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight">
                                    <img alt='' src={grid} /> </Link>
                                <div className="offcanvas offcanvas-end notification_side" tabIndex="-1" id="offcanvasRight" aria-labelledby="offcanvasRightLabel">
                                    <button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                                    <div className="offcanvas-header">
                                        <div className='modul_head'>
                                            <h5>All Module - <span>Forwarder</span></h5>
                                        </div>
                                    </div>
                                    <div className="offcanvas-body">
                                        <div className='module_airline'>
                                            <h3>CDM</h3>
                                            <div className='all_module'>
                                                <div className='module_item' onClick={() => forwarderCdmClick('RFS')}>
                                                    <img alt='' src={Rfs} />
                                                    <p>Shipment Manager</p>
                                                </div>

                                                <div className='module_item' onClick={() => forwarderCdmClick('ULD')}> {/* not live*/}
                                                    {/* <div className='module_item' onClick={() => window.location.href ='https://portal.trucking.aero/Forms/Forwarders/forwarder-bookinglist_admin?tab=uld'}>   */}
                                                    <img alt='' src={Uldm} />
                                                    <p>ULD Control</p>
                                                </div>
                                                <div className='module_item' onClick={() => forwarderCdmClick('DVR')}> {/* not live*/}
                                                    {/* <div className='module_item' onClick={() => window.location.href ='https://portal.trucking.aero/Forms/Forwarders/forwarder-bookinglist_admin?tab=uld'}>   */}
                                                    <img alt='' src={Uldm} />
                                                    <p>Driver/Visitor Registration</p>
                                                </div>
                                            </div>
                                        </div>

                                        <div className='module_airline'>
                                            <h3>CCLP</h3>
                                            <div className='all_module'>

                                                <div className='module_item' onClick={() => forwarderCCLP('cargo-claim')}>
                                                    <img alt='' src={Claim} />
                                                    <p>Cargo Claims</p>
                                                </div>

                                                <div className='module_item' onClick={() => forwarderCCLP('cargo-image')}>
                                                    <img alt='' src={Ulddam} />
                                                    <p>Cargo Image</p>
                                                </div>

                                                <div className='module_item' onClick={() => forwarderCCLP('export-acceptance')}>
                                                    <img alt='' src={Truck_info} />
                                                    <p>Export Acceptance</p>
                                                </div>

                                                <div className='module_item' onClick={() => forwarderCCLP('truck-inspection')}>
                                                    <img alt='' src={Export_in} />
                                                    <p>Truck Inspection</p>
                                                </div>

                                                <div className='module_item' onClick={() => forwarderCCLP('cargo-damage')}>
                                                    <img alt='' src={SReco} />
                                                    <p>Cargo Damage</p>
                                                </div>

                                            </div>
                                        </div>

                                        <div className='module_airline'>
                                            <h3>QMS</h3>
                                            <div className='all_module'>
                                                <div className='module_item'>
                                                    <img alt='' src={Inspection} />
                                                    <p>Audit Control</p>
                                                </div>

                                                <div className='module_item'>
                                                    <img alt='' src={Events} />
                                                    <p>Event Manager</p>
                                                </div>

                                                <div className='module_item'>
                                                    <img alt='' src={Learing} />
                                                    <p>Training Manager</p>
                                                </div>

                                                <div className='module_item'>
                                                    <img alt='' src={Semester} />
                                                    <p>Training Scheduler</p>
                                                </div>

                                                <div className='module_item'>
                                                    <img alt='' src={Quality} />
                                                    <p>Document Manager</p>
                                                </div>

                                                <div className='module_item'>
                                                    <img alt='' src={License} />
                                                    <p>License Manager</p>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </>
                        }
                        <Dropdown className="nav-profile">
                            <Dropdown.Toggle variant="link" id="dropdown-basic">
                                <span>
                                    <span className="success">{userDetails?.user_name}</span>
                                    {/* <br />Daniel Mckee */}
                                </span>
                                <span className="prof-img"><FontAwesomeIcon icon={faUser} /></span>
                                {/* <img alt='' src={face} alt="profile"/> */}
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                                <Dropdown.Item>
                                    <div className="dropdown-item preview-item no-cursor p-0">
                                        <div className="preview-item-content">
                                            <h6 className="preview-subject font-weight-normal">Welcome {userDetails?.user_name}</h6>
                                            <p className="font-weight-light small-text mb-0 text-muted">
                                                {userDetails?.email_id}
                                            </p>
                                        </div>
                                    </div>
                                </Dropdown.Item>
                                <Dropdown.Item href="#" onClick={() => airlineCCLP('profile')}>
                                    <i className="ti-user text-primary"></i>
                                    Profile Settings
                                </Dropdown.Item>
                                <Dropdown.Item href="#/LogOut" onClick={() => Logout(true)}>
                                    <i className="ti-power-off text-primary"></i>
                                    Logout
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>


                    </ul>
                </div>
            </div >

        </>
    );
}
export default Header; 